import { render, staticRenderFns } from "./ImportPartnerPrices.vue?vue&type=template&id=66532ce5&scoped=true"
import script from "./ImportPartnerPrices.vue?vue&type=script&lang=js"
export * from "./ImportPartnerPrices.vue?vue&type=script&lang=js"
import style0 from "./ImportPartnerPrices.vue?vue&type=style&index=0&id=66532ce5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66532ce5",
  null
  
)

export default component.exports